"use client";

import React from "react";
import { useApp } from "./AppProvider";
import RichText from "./RichText";
import RenderBlocks from "./blocks/RenderBlocks";
import type { PageData, ServiceItem } from "@/lib/cms";

export default function BilingualPageContent({ data }: { data: PageData | ServiceItem }) {
  const { isRTL } = useApp();

  const title = isRTL ? (data.title_ar || data.title_en) : data.title_en;
  
  // Use new blocks layout if present, otherwise fallback to richText content
  const blocks = isRTL 
    ? (data as any).layout_ar 
    : (data as any).layout_en;

  const hasBlocks = blocks && Array.isArray(blocks) && blocks.length > 0;

  // Legacy Content fallback
  const content = isRTL 
    ? ((data as any).content_ar || (data as any).content_en) 
    : ((data as any).content_en || (data as any).content_ar);

  return (
    <article style={{ direction: isRTL ? "rtl" : "ltr", textAlign: isRTL ? "right" : "left", paddingBottom: "8rem" }}>
      <header style={{ marginBottom: "4rem" }}>
        <h1 style={{
          fontSize: "clamp(2.5rem, 6vw, 5rem)",
          fontWeight: 900,
          color: "var(--text-primary)",
          letterSpacing: "-0.03em",
          lineHeight: 1,
          marginBottom: "1.5rem"
        }}>
          {title}
        </h1>
        <div style={{ width: 80, height: 6, background: "var(--gradient-brand)", borderRadius: 3 }} />
      </header>

      <div className="page-main-content" style={{ maxWidth: 900, marginInline: "0 auto" }}>
        {hasBlocks ? (
          <RenderBlocks blocks={blocks} />
        ) : (
          <div style={{ maxWidth: 800 }}>
            <RichText content={content} />
          </div>
        )}
        {/* Final clearfix for elements after the content */}
        <div style={{ clear: "both" }} />
      </div>
    </article>
  );
}
